.cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  margin-top: 1.5rem;
}

.arrow {
  width: 1.25rem;
  height: 1.25rem;
}
